const localeRegex = new RegExp(`\\b${process.env.GATSBY_LOCALE || "gb"}\\b`)

/**
 * Filter products by regex locale
 * @param {Array} products
 * @description Filter out all products that don't include the GATSBY_LOCALE value.
 * @returns {Array}
 */
export const filterProductsByRegexLocale = products =>
  products.filter(
    product => product.metafield && localeRegex.test(product.metafield.value),
  )

/**
 * Filter products by JSON locale.
 * @param {Array} products
 * @description Filter out all products that don't include the GATSBY_LOCALE value.
 * @returns {Array}
 */
export const filterProductsByJsonLocale = products => {
  return products.filter(
    product =>
      product.metafield &&
      JSON.parse(product.metafield.value).includes(process.env.GATSBY_LOCALE),
  )
}
